// @flow
import React, { Component } from 'react'
import moment from 'moment'
import { ChartCard } from '../../styles/mixins'
import { Chart, Axis, Tooltip, Geom, Legend, Guide } from 'bizcharts'
import { DataSet } from '@antv/data-set'
const { Region, Line } = Guide;
class ChartRisk2 extends Component {
  
  state: State = {
    dataSet: false,
    selectedDate: moment()
  }
  
  render() {
    
    // --- Data ---
    const { scenarios, xAxis, dates = [], isIVChart, assetPrice } = this.props
    const fields = []
    const data = []

    if (!isIVChart) {
      scenarios.forEach((sc)=> {
        fields.push(`${sc.name} ${moment(sc.expireDate).format('YYYY-MM-DD')}`);
        fields.push(`${sc.name} ${moment(sc.minExpireDate).format('YYYY-MM-DD')}`);
      })

      xAxis.forEach((x, index)=>{
        const obj = {}
        obj.price = x
        scenarios.forEach((sc)=> {
          obj[`${sc.name} ${moment(sc.expireDate).format('YYYY-MM-DD')}`] = sc.yAxis[index]
          obj[`${sc.name} ${moment(sc.minExpireDate).format('YYYY-MM-DD')}`] = sc.yAxis2[index]
        })
        data.push(obj)
      })
    } else {
      scenarios.forEach((sc, index)=> {
        const ivData = sc.ivData;
        Object.keys(ivData).forEach(ivd => {
          const name = `sc${index}tran${ivd}`
          const ivs = ivData[ivd] || []
          ivs.forEach((iv, ivIndex) => {
            const obj = {}
            obj.price = dates[ivIndex] && moment(dates[ivIndex]).format('DD')
            obj.value = (iv && !isNaN(iv.replace('%', '')) && parseFloat(iv.replace('%', ''))) || 0;
            obj.type = name;
            data.push(obj);
          });
          fields.push(name);
        })
      })
      return (
        <ChartCard loading={!data.length} bordered={false} title='Risk Profile'>
          <Chart height={400} data={data} forceFit>
            <Legend />
            <Axis name='price' />
            <Axis name='value' />
            <Tooltip crosshairs={{ type: 'y' }} />
            <Geom type='line' position='price*value' size={1} color={'type'} />
          </Chart>
        </ChartCard>
      )
    }

    const calcDataSet = () => {
      
      const ds: DataSet = new DataSet()
      const dv: Object = ds.createView().source(data)
      dv.transform({
        type: 'fold',
        fields: fields,
        key: 'date',
        value: 'pnl'
      })
      return dv
    }

    return (
      <ChartCard loading={!data.length} bordered={false}>

        <Chart height={400} data={calcDataSet()} forceFit background={{
          fill: '#fff',}}>
          <Legend />
          <Axis name='price' />
          <Axis name='pnl' label={{ formatter: val => `$${val}` }} />
          <Tooltip crosshairs={{ type: 'y' }}/>
          <Geom type='line' position='price*pnl' size={1} color={'date'} />
          <Guide>
            <Region
              start={["min", 0]}
              end={["max",50000000]}
              style={{
                fill: "#5AC405",
                fillOpacity: 0.05
              }}
            />
            <Region
              start={["min", -5000000]}
              end={["max", 0]}
              style={{
                fill: "#e00e0e",
                fillOpacity: 0.05
              }}
            />
            {
              assetPrice &&
              <Line
                start={[assetPrice, "min"]}
                end={[assetPrice, "max"]}
                text={{
                  content: `${this.props.symbol} $${assetPrice}`,
                  position: "end",
                  autoRotate: false,
                  style: {
                    textAlign: "center",
                    'margin-top': '15px',
                  }
                }}
              />
            }
          </Guide>
        </Chart>
      
      </ChartCard>
    )
  }
}

export default ChartRisk2



// WEBPACK FOOTER //
// ./src/components/chart-risk/chartRisk2.js